module.exports = __webpack_public_path__ + "static/media/2008_GDP_totalRate.38be6973.png";